/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Image, Text, VStack } from '@chakra-ui/react';
import { ReactNode, useState } from 'react';
import { IModules } from '@/service/types';

export const Label = ({ children }: { children: ReactNode }) => {
  return (
    <Text fontFamily={'Glory'} fontWeight={500} fontSize={20} color="black">
      {children}
    </Text>
  );
};

export const BenefitsItem = ({
  maskColor,
  title,
  benefitTitle,
  icon,
  url,
  is_external,
  metadata,
  onNavigateModule,
  isNative,
  isLoading,
}: IModules & { isLoading?: boolean; metadata?: any }) => {
  const [imageError, setImageError] = useState(false);

  const handleImageError = () => {
    setImageError(true);
  };

  const handleClick = () => {
    if (isLoading) return;

    if (!url) {
      return;
    }
    onNavigateModule(url, is_external, metadata);
  };

  // Seções que pintam o ícone com a cor da marca (maskColor).
  const isMasked = benefitTitle === 'Economizar' || benefitTitle === 'Benefícios Para Ler';

  const iconPadding = {
    base: isNative ? '12px' : '20px',
    sm: '20px',
    md: '20px',
    lg: '20px',
  };

  return (
    <Box
      sx={{
        '&:hover': {
          textDecoration: 'none',
        },
      }}
      cursor={isLoading ? 'not-allowed' : 'pointer'}
      onClick={handleClick}
      opacity={isLoading ? 0.6 : 1}
      transition="opacity 0.2s"
      height="100%"
      display="flex"
      flexDirection="column"
    >
      <VStack width="100%" height="100%" align={'center'} justifyContent={'space-between'}>
        <Box
          width="100%"
          height={'100%'}
          maxH={{
            base: isNative ? '57px' : '100px',
            sm: '115px',
            md: '125px',
            lg: '135px',
          }}
          minH={{
            base: isNative ? '57px' : '100px',
            sm: '115px',
            md: '125px',
            lg: '135px',
          }}
          borderRadius={{
            base: isNative ? '12px' : '24px',
            sm: isNative ? '12px' : '24px',
            md: isNative ? '12px' : '12px',
            lg: '24px',
          }}
          bg="white"
        >
          <Box position={'relative'} width="100%" height={'100%'}>
            <Image
              margin={'auto'}
              padding={iconPadding}
              minH={{
                base: isNative ? '57px' : '100px',
                sm: '115px',
                md: '125px',
                lg: '135px',
              }}
              maxH={{
                base: isNative ? '57px' : '100px',
                sm: '115px',
                md: '125px',
                lg: '135px',
              }}
              width={isNative ? '100%' : '100%'}
              height={'100%'}
              objectFit="contain"
              borderRadius="30px"
              position="relative"
              zIndex={1}
              src={
                imageError
                  ? 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiBmaWxsPSIjRjVGNUY1Ii8+Cjx0ZXh0IHg9IjUwIiB5PSI1MCIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjEyIiBmaWxsPSIjOTk5IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+SWNvbmU8L3RleHQ+Cjwvc3ZnPgo='
                  : icon
              }
              onError={handleImageError}
              fallbackSrc="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiBmaWxsPSIjRjVGNUY1Ii8+Cjx0ZXh0IHg9IjUwIiB5PSI1MCIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjEyIiBmaWxsPSIjOTk5IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+SWNvbmU8L3RleHQ+Cjwvc3ZnPgo="
              alt={title}
            />
            {isMasked && (
              <Box
                position={'absolute'}
                top={0}
                left={0}
                width="100%"
                height={'100%'}
                borderRadius={{
                  base: isNative ? '12px' : '24px',
                  sm: isNative ? '12px' : '24px',
                  md: isNative ? '12px' : '12px',
                  lg: '24px',
                }}
                zIndex={2}
                pointerEvents="none"
                // Só aplica a cor + blend onde o WebView suporta mix-blend-mode.
                // Sem suporte, o overlay fica transparente e o ícone original
                // aparece normal (em vez de virar um bloco sólido).
                sx={{
                  '@supports (mix-blend-mode: color)': {
                    backgroundColor: maskColor,
                    mixBlendMode: 'color',
                  },
                }}
              />
            )}
          </Box>
        </Box>
        <Text
          color="#747474"
          fontWeight={'500'}
          fontSize={isNative ? '0.8rem' : '16px'}
          fontFamily={'Glory'}
          whiteSpace={'normal'}
          textAlign={'center'}
        >
          {title}
        </Text>
      </VStack>
    </Box>
  );
};
